import React from "react";
import Banner from "../../Components/Banner";
import CryptoTable from "../../Components/CryptoTable";

const Home = () => {
	return (
		<>
			<Banner />
			<CryptoTable />
		</>
	);
};

export default Home;
